import { compose } from 'recompose'
import toReduxFormField from 'sidecar-utils/lib/enhancers/toReduxFormField'

const enhance = compose(toReduxFormField('InputText'))

export default enhance



// WEBPACK FOOTER //
// ./src/sidecar-ui/lib/InputText/enhance.js